// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"a2d6b7b6","998":"a2d6b7b6"}[chunkId] + ".chunk.css";
};